import DOMPurify, { Config } from 'dompurify';

export const safeHtml = (str: string, opts?: Config): ReturnType<typeof DOMPurify.sanitize> => {
  return DOMPurify.sanitize(decodeURI(str), opts);
};
